import type { BackgroundDocT, FactT } from '../../../data/api.js';

/** Label an accepted fact with its document or manual source. */
export function sourceLabel(fact: FactT, docs: readonly BackgroundDocT[]): string {
  if (fact.sourceDocumentId !== null) {
    const doc = docs.find((candidate) => candidate.id === fact.sourceDocumentId);
    return doc === undefined ? 'Source document unavailable' : `From ${doc.title ?? doc.filename}`;
  }
  return fact.sourceKind === 'manual' ? 'Added by a person' : `From ${fact.sourceKind}`;
}
